import { ApproversListResult } from 'api/services/Admin';
import { UserRoles } from 'components/Auth/AuthProvider';

export function getRolesFromToken(token: string | undefined): Array<UserRoles> {
  const parts = token && token.split('.');
  if (parts) {
    var part1 = JSON.parse(window.atob(parts[1]));
    if (part1) {
      // console.log(part1.roles);
      return part1.roles;
    }
  }
  return [];
}

export function isUserApprover(
  approvers: ApproversListResult[],
  adUser: string
): boolean {
  const uniqueEmployeeIds = Array.from(
    new Set(approvers.map((approver) => approver.employeeId.toUpperCase()))
  );
  return uniqueEmployeeIds.includes(adUser.toUpperCase());
}
